// extracted by mini-css-extract-plugin
export var numpadContainer = "_n8-1";
export var phoneButton = "_n8-0";